import React, { useContext, useEffect, useState } from "react";
import { Layout, Avatar, Dropdown, Menu, Button, Tooltip } from "antd";
import { MenuUnfoldOutlined, DownOutlined, LogoutOutlined } from "@ant-design/icons";
import { API_URL } from "../../services/api";
import { useHistory } from "react-router-dom";
import useHttp from "../../hooks/useHttp";
import AuthContext from "../../store/AuthContext";
import ChatContext from "../../store/ChatContext";
import featherEdit from '../../Images/feather-edit.svg';
import ailogowhite from '../../Images/ailogo-white.svg';
import { generateUUID } from '../../utils/generateUUID';

const { Header: AntHeader } = Layout;

const Header = ({collapsed, onCollapse, onShowLogs, showLogs}) => {
  const history = useHistory();
  const {postRequest, getRequest} =  useHttp();
  const chatCtx = useContext(ChatContext);
  const authCtx = useContext(AuthContext);
  const [agents, setAgents] = useState([]);  
  const [agentContextMapping, setAgentContextMapping] = useState({});

  useEffect(() => {
    getRequest({
      url: `${API_URL}/app/validateUser`,
    onResponse: (response) => {
     if(response.employerOrgEin){
      //do nothing
      getRequest({
        url: `${API_URL}/app/getProfile`,
        onResponse: (response) => {
          authCtx.setUserDetails('employerOrgEin', response.employerOrganizationEin);
        },
        onError: (err) => {
          console.error("Error getting profile", err.message);
        }
      });
     }else if(response==='failure'){
      history.push("/login");
     }
    }, onError: (err) => {
      console.error("Error validating user", err.message);
      history.push("/login");
    } },);

    
  }, [history]);

  // useEffect(() => {
  //   getRequest({
  //     url: API_URL + `/app/ap1/agent/fetch/all`,
  //     onResponse: (response) => {
  //       console.log("response", response);
  //       setAgents(response);
  //       // Set default agentId to 'copilotGraph-001' if available and not already set
  //       if (!chatCtx.agentId && Array.isArray(response)) {
  //         const copilotAgent = response.find(agent => agent.agentId === 'copilotGraph-001');
  //         if (copilotAgent) {
  //           chatCtx.setAgentId('copilotGraph-001');
  //         } else if (response.length > 0) {
  //           chatCtx.setAgentId(response[0].agentId);
  //         }
  //       }
  //     },
  //     showLoader: false
  //   });
  // }, []);

  // useEffect(() => {
  //   getRequest({
  //     url: API_URL + `/app/agentmgr/agent/agentContextMapping`,
  //     onResponse: (response) => {
  //       console.log("agent context mapping response:", response);
  //       setAgentContextMapping(response);
  //       chatCtx.setAgentContextMapping(response);
  //     },
  //     onError: (err) => {
  //       console.error("Error fetching agent context mapping:", err.message);
  //     },
  //     showLoader: false
  //   });
  // }, []);

  const handleLogout = async () => {
    await postRequest({
      url: `${API_URL}/app/logout`,
      data: {},
      headers: { "Content-Type": "application/json" },
      onResponse: (data) => {
        history.push("/login");
      },
      onError: async (err) => {
        console.error("Error Logging out", err.message);
      }
    });
  };

  const dropdownItems = {
    items: [
      {
        key: "logout",
        label: "Logout",
        icon: <LogoutOutlined />,
        onClick: handleLogout,
      },
    ],
  };

  const onAgentChange = (value) => {
    chatCtx.setAgentId(value);
    chatCtx.onChatRefresh();
  };

  const handleNewChat = () => {
    // let chatIdentifier = 'newChat';
    let chatIdentifier = `new-${generateUUID()}`;
    history.push(`/chat/` + chatIdentifier);
  };

  const handleShowLogs = () => {
    onShowLogs(!showLogs);
  };

  return (
    <AntHeader className="flex justify-between items-center bg-white px-2 !h-10 border-b border-gray-200">
      {/* <div className="text-xl font-semibold ml-8">UZIO.AI</div> */}
     <div className="flex items-center gap-3 ">
        <div className=" flex items-center">
        {collapsed && <MenuUnfoldOutlined className="text-gray-600 ml-3 text-xl cursor-pointer" onClick={()=>{onCollapse(!collapsed)}} />}
       <img src={ailogowhite} className="w-6 mx-2" alt="AI" /> AI Copilot
       
        </div>
      </div>

      <div className="flex items-center gap-3 mr-16 ">
      {
      // agents.length > 1 && (
      // <Dropdown
      //   className="!p-0 !m-0"
      //     overlay={
      //       <Menu 
      //       onClick={({ key }) => onAgentChange(key)}>
      //         {agents.map((agent) => (
      //           <Menu.Item className={`${agent.agentId === chatCtx.agentId ? 'bg-gray-100' : ''}`} active={agent.agentId === chatCtx.agentId} key={agent.agentId}>{agent.name}</Menu.Item>
      //         ))}
      //       </Menu>
      //     }
      //   >
      //     <Button type="text" className="bg-gray-100  text-gray-600">
      //       {/* <span className="!text-sm !max-w-[150px]   !overflow-hidden !text-ellipsis !whitespace-nowrap">
      //       {agents.find(agent => agent.agentId === chatCtx.agentId)?.name || (agents.find(agent => agent.agentId === 'copilotGraph-001') ? 'copilotGraph-001' : 'Select Agent')}
      //       </span> */}
      //       <DownOutlined />
      //     </Button>
      //   </Dropdown>)
        }
        <Dropdown
          menu={dropdownItems}
          placement="bottomRight"
          trigger={["click"]}
          className="webPortal"
        >
          <div className="flex items-center gap-3 cursor-pointer">
            <div className="mr-2">
            <Avatar size="large">
            {(authCtx.userDetails.displayName)?.split(' ')?.map(word => word[0]?.toUpperCase())?.join('')}
            </Avatar>
            </div>
            <span className="text-gray-600">
              {authCtx.userDetails.displayName}
            </span>
          </div>
        </Dropdown>
        <Tooltip title="New Chat">
        {/* <img src={featherEdit} alt="edit" className="w-4 h-4 cursor-pointer mr-1" onClick={() => history.push('/chat')}/> */}
        <img src={featherEdit} alt="edit" className="w-4 h-4 cursor-pointer mr-1" onClick={() => handleNewChat()}/>
      </Tooltip>
      </div>
    </AntHeader>
  );
};

export default Header;
